import {qspost} from '@/plugins/axios'

/*
 * 文件列表
 * @constructor jack
 * */
export const articleList = (searchName, type, page, pageSize) => qspost('/Index/Article/articleList', {
  searchName, type, page, pageSize
})

/*
 * 文件删除
 * @constructor jack
 * */
export const articleDel = (id) => qspost('/Index/Article/articleDel', {
  id
})

/*
 * 文件添加修改
 * @constructor jack
 * */
export const articleAdd = (name, url, type, id) => qspost('/Index/Article/articleAdd', {
  name, url, type, id
})


/*
* 五级联动
* */
/*
 * 第一级：项目列表
 * @constructor jack
 * */
export const getXiangMuList = () => qspost('/Index/Jumin/getXiangMuList', {})

/*
 * 第二级：小区列表
 * @constructor jack
 * */
export const getXiaoQuList = (xiangMuId) => qspost('/Index/Jumin/getXiaoQuList', {xiangMuId})

/*
 * 第三级：楼号列表
 * @constructor jack
 * */
export const getLouHaoList = (xiaoQuId) => qspost('/Index/Jumin/getLouHaoList', {xiaoQuId})

/*
 * 第四级：单元列表
 * @constructor jack
 * */
export const getDanYuanList = (louHaoId) => qspost('/Index/Jumin/getDanYuanList', {louHaoId})

/*
 * 第五级：房间列表
 * @constructor jack
 * */
export const getFangJianList = (danYuanId) => qspost('/Index/Jumin/getFangJianList', {danYuanId})

/*
 * 第五级：员工列表
 * @constructor jack
 * */
export const getAdminByXiaoquId = (xiaoqu_id) => qspost('/Index/Xinxuqiu/getAdminByXiaoquId', {xiaoqu_id})

/*
 * 员工/小区照片
 * @constructor jack
 * */
export const addImage = (id,type,image) => qspost('/Index/Datascreen/addImage', {id,type,image})


/*
 * */
export const getQiniuUrl = (path) => qspost('/index/common/getQiniuUrl', {path})

